export default __webpack_public_path__ + "static/smreflex-f0f641aaebf09088a19b3deb5ae4d282.svg";